var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import query from '../../../mediaQueries';
export var MarketingPreferenceWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 87%;\n  max-width: 942px;\n  margin: 0 auto;\n\n  @media ", " {\n    width: 92%;\n  }\n"], ["\n  width: 87%;\n  max-width: 942px;\n  margin: 0 auto;\n\n  @media ", " {\n    width: 92%;\n  }\n"])), query.lessThanSmall);
export var MarketingPreferenceItemWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
